import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import classNames from 'classnames/bind';
import Button from '../Button';

import styles from './hero.module.scss';

const cx = classNames.bind(styles);

function Hero(props) {
  const {
    cta,
    image,
    media,
    subtitle,
    title,
    videoUrl,
  } = props;

  const heroClassName = cx({
    hero: true,
    withMedia: !!media,
  });

  return (
    <div className={heroClassName}>
      {image && (
        <div className={styles.bgImage} style={{ backgroundImage: `url('${image.file.url}')` }} />
      )}

      {videoUrl && (
        <div className={styles.videoContainer}>
          <video
            className={styles.video}
            poster={image.file.url}
            loop
            autoPlay
            muted
          >

            <source
              src={videoUrl}
              type="video/mp4"
            />
              Your browser doesn&quot;t support HTML5 video tag.
          </video>
        </div>
      )}

      <div className={styles.content}>
        {media && (
          <React.Fragment>
            {media.image.file.contentType === 'image/svg+xml' ? (
              <img src={media.image.file.url} className={styles.contentImage} alt={media.title} />
            ) : (
              <Img
                className={styles.contentImage}
                fluid={media.image.fluid}
                alt={media.title}
              />
            )}
          </React.Fragment>
        )}

        {title && !media && (
          <h1 className={styles.title}>{title}</h1>
        )}

        {subtitle && !media && (
          <h2 className={styles.subtitle}>{subtitle}</h2>
        )}

        {cta && !media && (
          <Button
            {...cta}
            link={cta.url}
            variant="secondary"
            isMobileFull
          >
            {cta.label}
          </Button>
        )}
      </div>
    </div>
  );
}

export default Hero;

Hero.propTypes = {
  cta: PropTypes.shape({
    url: PropTypes.string,
    label: PropTypes.string,
  }),
  image: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  media: PropTypes.shape({
    image: PropTypes.object,
    title: PropTypes.string,
  }),
  subtitle: PropTypes.string,
  title: PropTypes.string,
  videoUrl: PropTypes.string,
};

Hero.defaultProps = {
  cta: {
    url: '',
    label: '',
  },
  image: {
    file: {
      url: '',
    },
  },
  media: {
    title: '',
  },
  subtitle: '',
  title: '',
  videoUrl: '',
};
